/**
 * 라우트 경로 상수.
 * router/index.tsx 와 navigate 호출 곳들이 같은 path 를 참조하도록 단일 출처.
 */
export const ROUTES = {
  ROOT: '/',
  SEARCH: '/search',
} as const

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES]
